export const version = {
  version: 'v3.8',
};
